module.exports = __webpack_public_path__ + "img/bottom.d6036b55.png";